<!-- Geometry matches Skeleton Screens.dc.html `skelService` Estimated Costs rail. -->
<div class="estimated-costs-skeleton" aria-hidden="true" data-testid="estimated-costs-skeleton">
  <app-skeleton-block width="176" height="24" />
  <div class="estimated-costs-skeleton__divider"></div>

  @for (line of linePlaceholders; track line) {
    <div class="estimated-costs-skeleton__row">
      <app-skeleton-block width="96" height="11" tone="secondary" />
      <app-skeleton-block width="58" height="11" tone="secondary" />
    </div>
  }

  <div class="estimated-costs-skeleton__divider"></div>

  <div class="estimated-costs-skeleton__row">
    <app-skeleton-block width="68" height="15" />
    <app-skeleton-block width="76" height="15" />
  </div>
</div>
